import {isFulfilled, isPending, isRejected} from "@reduxjs/toolkit";
import {addPopup, requestEnded, requestStarted} from "../actions";
import * as popups from "constants/popup-types";

export function apiMiddleware(storeApi) {
    return function wrapDispatch(next) {
        return function handleAction(action) {

            if (isPending(action)) {
                storeApi.dispatch(requestStarted())
            }

            if (isFulfilled(action)) {
                storeApi.dispatch(requestEnded())
            }

            if (isRejected(action)) {
                console.log('isRejected: ', action)
                storeApi.dispatch(requestEnded())
                if (action?.payload?.popupOnError !== false)
                    storeApi.dispatch(
                        addPopup({type: popups.API_MESSAGE, text: action?.payload?.data})
                    )
            }

            next(action)

        }
    }
}
